import { DariCalendarService } from '../../../services/DariCalendar';
import { Global } from '../../global';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GL_Child } from '../../../models/GL_Child';
import { GL_Master } from '../../../models/GL_Master';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { MatSnackBar } from '@angular/material';
import { ExcelService } from '../../../services/ExcelService';
import { isEmpty } from 'rxjs/operators';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-gl-child',
  templateUrl: './gl-child.component.html',
  styleUrls: ['./gl-child.component.css']
})
export class GlChildComponent implements OnInit {
  ArrLabels: any;
  labels: any = {};
  pageIndex: number = 0;
  pageSize: number = 100;
  recordCount;
  gl_childs: any;
  GL_Child_Name;
  GL_Child_Code;
  gl_Master: GL_Master = {
    GL_Code: "",
    GL_Desc: "",
    GL_Desc_en: "",
    GL_CategoryID: 0,
    GL_CategoryDesc: "",
    GL_CategoryDesc_en: "",
    RecordStat: "",
    AuthStat: "",
    MakerID: "",
    CheckerID: "",
    CreateDate: new Date(),
    branchId: 0,
    branchName:''
  };

  constructor(
    private DariCalendar: DariCalendarService,
    private GL_MasterService: GL_MasterService,
    private UtilityService: UtilityService,
    private global: Global,
    public snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private excelService: ExcelService) {

    route.params.subscribe(p => {
      this.gl_Master.GL_Code = p['gL_Code'];
    });
  }

  ngOnInit() {
    this.getLabels();
    this.pageIndex = 0;
    this.pageSize = 100
    this.getGlChilds(this.pageIndex);
    this.getRecordCount();
    console.log("Records Count: " + this.recordCount);
  }
  search() {
    this.pageIndex = 0;
    this.getGlChilds(this.pageIndex);
    this.getRecordCount();
  }
  clear () { this.GL_Child_Code = this.GL_Child_Name = undefined; }
  getRecordCount() {
    this.GL_MasterService.getRecordCount(this.gl_Master.GL_Code, this.GL_Child_Code,this.GL_Child_Name).subscribe(r => {
      this.recordCount = Number.parseInt(r.json());
    });
  }
  previousPage(jump: number) {
    this.pageIndex = this.pageIndex >= jump ? this.pageIndex - jump : 0;
    this.getGlChilds(this.pageIndex);
  }
  nextPage(jump: number) {
    this.pageIndex = this.recordCount - this.pageSize >= this.pageIndex + jump ? this.pageIndex + jump : this.recordCount - this.pageSize;
    this.getGlChilds(this.pageIndex); 
  }
  getGlChilds(pageIndex: number) {
    this.GL_MasterService.getGL_Childsp(this.gl_Master.GL_Code, pageIndex, this.pageSize, this.GL_Child_Code, this.GL_Child_Name)
      .subscribe(response => {
        if (response) {
          this.gl_childs = response;
          for (let i in this.gl_childs) {
            this.gl_childs[i].createDate_da = this.DariCalendar.PersianCalendar(new Date(this.gl_childs[i].createDate));
          }
          console.log(response);
        }
      },
        error => console.log("error --> " + error))
  }

  deleteGLChild(gl_childCode: string) {
    if (!confirm("تایید؟"))
      return;

    this.GL_MasterService.DeleteGL_Child(gl_childCode)
      .subscribe(response => {

        if (response == 'hasTrnsactions')
          //console.log('hasTransactions');
          this.openSnackBarInfo('اکانت جورنال دارد', 'خطا')
        else if (response == 'notExist')
          //console.log("GL child does not exist.");
          this.openSnackBarInfo('اکانت موجود نیست', 'خطا')
        else {
          //console.log("delete succeed -- " + response);
          this.openSnackBarInfo('اکانت حذف شد', '')
          var glForDelete = this.gl_childs.find((o: any) => o.gL_ChildCode === gl_childCode);
          this.gl_childs.splice(this.gl_childs.indexOf(glForDelete), 1);
          //this.getGlChilds(); 
        }
      }
        , error => console.log("error --> " + error))

  }

  openSnackBarInfo(message: string, action: string) {
    let snackBarRef = this.snackBar.open(message, action, {
      duration: 2000,
    });
    snackBarRef.closeWithAction = function () {
      snackBarRef.dismiss();
    }
  }

  //exportAsXLSX(): void {
  //  this.excelService.exportAsExcelFile(this.gl_childs, 'Student List');
  //}

  @ViewChild('tableReport') table: ElementRef;
  exportAsXLSX(): void {
    //this.excelService.exportAsExcelFile(this.invoiceList, 'invoiceList');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'studentList.xlsx');
  }

  getLabels() {
    this.UtilityService.getLabels('gl-child', this.global.lang)
      .subscribe(response => {
        if (response) {
          this.ArrLabels = response;
          this.setLabels();
        }
      },
        error => console.log(error))
  }

  setLabels() {

    this.labels['gl-child-Title'] = this.ArrLabels.find((o: any) => o.key === 'gl-child-Title').value;
    this.labels['AccountID'] = this.ArrLabels.find((o: any) => o.key === 'AccountID').value;
    this.labels['MasterAccountID'] = this.ArrLabels.find((o: any) => o.key === 'MasterAccountID').value;
    this.labels['AccountName'] = this.ArrLabels.find((o: any) => o.key === 'AccountName').value;
    this.labels['AccountName_en'] = this.ArrLabels.find((o: any) => o.key === 'AccountName_en').value;
    this.labels['CurrentBalance'] = this.ArrLabels.find((o: any) => o.key === 'CurrentBalance').value;

    // shared labels.
    this.labels['RecordStat'] = this.ArrLabels.find((o: any) => o.key === 'RecordStat').value;
    this.labels['AuthStat'] = this.ArrLabels.find((o: any) => o.key === 'AuthStat').value;
    this.labels['CreateDate'] = this.ArrLabels.find((o: any) => o.key === 'CreateDate').value;
    this.labels['CheckerID'] = this.ArrLabels.find((o: any) => o.key === 'CheckerID').value;
    this.labels['MakerID'] = this.ArrLabels.find((o: any) => o.key === 'MakerID').value;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/GLs/gl-child/gl-child.component.ts